import { ShipStatus } from './ship-status.js';
/** DELIVERED alone -- Ship has no cancelled state, so an abandoned shipment holds the warehouse. */
export const TERMINAL_SHIP_STATUS_IDS = [ShipStatus.DELIVERED];
//# sourceMappingURL=ship-terminal-statuses.js.map